/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NotificaPushBroadcastForm { 
    /**
     * Titolo della notifica, mostrato in grassetto sul dispositivo.
     */
    titolo: string;
    /**
     * Corpo del messaggio.
     */
    messaggio: string;
    /**
     * Filtro opzionale per Comune. ATTENZIONE: seleziona i cittadini che hanno almeno una pratica su un bando di questo Comune, NON i residenti — un cittadino registrato che non ha mai presentato domanda non appartiene ad alcun Comune ed e\' raggiungibile solo omettendo questo filtro. Assente = tutti i cittadini della piattaforma.
     */
    comune_id?: string;
}

